import { clx, Label } from '@medusajs/ui';

export const StatusLabelStyleMap = {
  green: 'bg-green-20_op10 text-green-20',
  orange: 'bg-orange-30_op10 text-orange-30',
  purple: 'bg-purple-30_op10 text-purple-10',
  red: 'bg-red-30_op10 text-red-30',
  grey: 'bg-white-40 text-black-10',
};

interface StatusLabelProps {
  className?: string;
  color: 'green' | 'orange' | 'purple' | 'red' | 'grey';
  children: React.ReactNode;
  size?: 'base' | 'small' | 'xsmall' | 'large' | undefined;
}

export const StatusLabel = ({
  className,
  children,
  color,
  size = 'base',
  ...props
}: StatusLabelProps) => (
  <Label
    {...props}
    size={size}
    className={clx(
      'inline-flex h-[30px] w-[86px] items-center justify-center rounded-md',
      StatusLabelStyleMap[color],
      className
    )}
  >
    {children}
  </Label>
);
